// extracted by mini-css-extract-plugin
export default {"discussnContainer":"discuss_discussnContainer__vBdMo","textLabel":"discuss_textLabel__94SMP"};